export interface ApiResponse<T> {
  success: boolean;
  statusCode: number;
  message: string;
  data: T;
  timestamp?: string;
}

export interface ApiError {
  success?: boolean;
  statusCode?: number;
  message: string | string[];
  errors?: string[];
}

export function isApiResponse<T>(data: unknown): data is ApiResponse<T> {
  return (
    typeof data === 'object' &&
    data !== null &&
    'data' in data &&
    ('success' in data || 'statusCode' in data)
  );
}
